module.exports = __webpack_public_path__ + "img/marinaLoshak.f62a15a9.jpg";